import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TransactionListTotalCostCell } from '@app/feature/transaction/transaction-list/transaction-list-total-cost.cell';
import { TransactionListTotalCostHeader } from '@app/feature/transaction/transaction-list/transaction-list-total-cost.header';

export const ChargePointChannelTransactionListTotalCostColumn: IdentifiedColumnDef<
  TransactionModel,
  TransactionModel['totalCost']
> = {
  enableSorting: false,
  header: TransactionListTotalCostHeader,
  cell: TransactionListTotalCostCell,
};
